export const environment = {
  production: true,
  blobUrl: 'CMETP-DEV-a8gjhbaygvawdpgn.a01.azurefd.net/communication-entreprise',
  youtubeAPI: 'https://www.youtube.com/iframe_api',
  piwikUrl: 'https://matomo.vinci-energies.net/',
  piwikSiteId: '119',
  mobileUrl: 'https://az102-cmetp-dev-wa-03-a3bdavgwf8cycudn.westeurope-01.azurewebsites.net/'
};
